import { render, staticRenderFns } from "./QuickBasket.vue?vue&type=template&id=b97c3b3a&scoped=true&"
import script from "./QuickBasket.vue?vue&type=script&lang=js&"
export * from "./QuickBasket.vue?vue&type=script&lang=js&"
import style0 from "./QuickBasket.vue?vue&type=style&index=0&id=b97c3b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97c3b3a",
  null
  
)

export default component.exports